
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/enviu/[slug]",
      function () {
        return require("private-next-pages/corporatiu/enviu/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/enviu/[slug]"])
      });
    }
  